import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    goBackToDashboard: {
        id: '_.outstanding_view.dashboardActionPanel.goBackToDashboard',
        defaultMessage: "I'll decide later"
    },
    topUpApprovalSummary: {
        id: '_.outstanding_view.dashboardActionPanel.topUpApprovalSummary',
        defaultMessage:
            'You can draw down up to {amount} with an interest rate of {interestRate} per month.'
    },
    withdrawMessage: {
        id: '_.outstanding_view.dashboardActionPanel.withdrawMessage',
        defaultMessage: 'I want to withdraw {input}'
    },
    drawdownCTA: {
        id: '_.outstanding_view.dashboardActionPanel.drawdownAmount',
        defaultMessage: 'Continue with {drawdownAmount}'
    },
    repaymentTitle: {
        id: '_.outstanding_view.dashboardActionPanel.repaymentsTitle',
        defaultMessage: 'Your repayments over {monthsSchedule} months'
    },
    repaymentScheduleCTA: {
        id: '_.outstanding_view.dashboardActionPanel.repaymentsScheduleCTA',
        defaultMessage: 'See your new schedule'
    },
    minimumRepaymentsLabel: {
        id: '_.outstanding_view.dashboardActionPanel.minimumRepaymentsLabel',
        defaultMessage: 'Minimum monthly repayment'
    },
    totalInterestLabel: {
        id: '_.outstanding_view.dashboardActionPanel.totalInterestLabel',
        defaultMessage: 'Total interest'
    },
    feesLabel: {
        id: '_.outstanding_view.dashboardActionPanel.feesLabel',
        defaultMessage: 'Fees'
    },
    totalRepaymentLabel: {
        id: '_.outstanding_view.dashboardActionPanel.totalRepaymentLabel',
        defaultMessage: 'Total repayment'
    },
    extendInterestOnly: {
        id: '_.outstanding_view.dashboardActionPanel.extendInterestOnly',
        defaultMessage: 'You can now extend your grace period by 3 months.'
    },
    extendInterestOnlyWithDrawdown: {
        id: '_.outstanding_view.dashboardActionPanel.extendInterestOnlyNoChoice',
        defaultMessage: 'Would you also like a credit increase?'
    },
    extendInterestOnlyCTA: {
        id: '_.outstanding_view.dashboardActionPanel.extendInterestOnlyCTA',
        defaultMessage: 'Extend my Interest Only Period'
    },
    tabInterestOnly: {
        id: '_.outstanding_view.dashboardActionPanel.tabInterestOnly',
        defaultMessage: 'Only extend interest-only period'
    },
    tabInterestOnlyWithDrawdown: {
        id: '_.outstanding_view.dashboardActionPanel.tabInterestOnlyWithDrawdown',
        defaultMessage: 'Draw down additional funds too'
    }
});
